import { render } from "./AdminjobsJSS.vue?vue&type=template&id=b480c29e&scoped=true"
import script from "./AdminjobsJSS.vue?vue&type=script&lang=js"
export * from "./AdminjobsJSS.vue?vue&type=script&lang=js"

import "./AdminjobsJSS.vue?vue&type=style&index=0&id=b480c29e&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b480c29e"]])

export default __exports__